module.exports = __webpack_public_path__ + "static/media/p4.8af822d8.jpeg";